import React from 'react';
import { CHECKOUT_URL } from '../data/content';
type Props = {
  label?: string;
  sub?: string;
  className?: string;
};
export function CTAButton({
  label = '🔴 QUIERO LA RUTA ANTICOAGULACIÓN AHORA',
  sub = 'Descarga inmediata · Sin suscripción · Acceso de por vida · Garantía 7 días',
  className = ''
}: Props) {
  return <div className={`w-full flex flex-col items-center ${className}`} data-id="element-26" data-mp="2fys78ntns5kj">
      <a href={CHECKOUT_URL} className="pulse-ring w-full max-w-xl rounded-2xl bg-brandred px-5 py-4 sm:py-5 text-center text-base sm:text-lg font-extrabold uppercase leading-snug tracking-wide text-white shadow-[0_10px_0_0_#9d0c24] transition-all duration-150 hover:bg-brandred-light active:translate-y-[6px] active:shadow-[0_4px_0_0_#9d0c24] focus:outline-none focus-visible:ring-4 focus-visible:ring-brandred/40" data-id="element-27" data-mp="2tykxki19wjrz">
        {label}
      </a>
      {sub ? <p className="mt-3 px-2 text-center text-[11px] sm:text-xs font-medium text-navy/60" data-id="element-28" data-mp="38oirzfpsq5pm">
          {sub}
        </p> : null}
    </div>;
}